import { Location } from '@angular/common'
import { Component, inject } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import {ToastrService} from "ngx-toastr";
import {AuthService} from "../../../core/auth/auth.service";

@Component({
  template: '',
  providers: [ ToastrService],
})
export class BaseComponent {
  currentUser!: any
  public toastService = inject(ToastrService)
  public router = inject(Router)
  public activatedRoute = inject(ActivatedRoute)
  public location = inject(Location)
  public authService = inject(AuthService)

  constructor() {
    this.initConnectedUser()
  }

  initConnectedUser() {
    this.authService.userSubject$.subscribe({
      next: (curentUser) => {
        this.currentUser = curentUser
      },
      error: () => {
        this.showError('Vous devez vous connecter')
      },
    })
  }

  showError(message: string | undefined) {
    this.toastService.error(message);
  }

  showWarn(message: string | undefined) {
    this.toastService.info(message)
  }

  showSuccessMessage(message: string | undefined) {
    this.toastService.success(message)
  }
}
